module.exports = __webpack_public_path__ + "static/media/JosefinSans-SemiBold.c1901ea4.ttf";